import React from 'react'
import { Container, Row, Col, Button, InputGroup, Input, Form, Label, FormText, InputGroupAddon } from 'reactstrap'
import './styles/login.css'
import Icon from './styles/icon';
// import HttpClient from './myapi';
import { SetLoggedIn } from './redux/actions/index'
import store from './redux/store'

export default class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            pswd: '',
            disableSubmit: false,
            wrong: false
        }

        this.handleChange = this.handleChange.bind(this)
        this.submit = this.submit.bind(this)
    }
    handleChange(e) {
        this.setState({ pswd: e.target.value, wrong: false })
    }

    submit(e) {
        e.preventDefault();
        this.setState({ disableSubmit: true });

        // HttpClient.post('/Login/doLogin.php', { pswd: this.state.pswd })
        //     .then((res) => {
        //         if (res === '*') {
        if (this.state.pswd === 'ajaY@473') {
            localStorage.setItem('isLoggged', 111);
            store.dispatch(SetLoggedIn(true))
            this.props.history.replace('/adminGallery');
        } else {
            this.setState({ wrong: true, disableSubmit: false, pswd: '' })
        }
    }
    // componentDidMount(){

    // }
    render() {
        return (
            <div style={{ overflow: 'hidden' }}>
                <h1 className="page-heading">Admin Login</h1>
                <Container>
                    <Row className="login-wrapper">
                        <Col md={{ size: 6, offset: 3 }} sm={{ size: 12, offset: 0 }}>
                            <Form onSubmit={this.submit}>
                                <div className="login-icon-big">
                                    <Icon icon="fa-unlock-alt" />
                                </div>

                                <Label>Enter Password</Label>
                                <InputGroup>
                                    <Input type="password"
                                        placeholder="Enter Password"
                                        value={this.state.pswd}
                                        onChange={this.handleChange} />
                                    <InputGroupAddon addonType="append">
                                        <Button className="theme-button"
                                            disabled={!this.state.pswd || this.state.disableSubmit} >
                                            <Icon icon="fa-sign-in-alt" /> Login
                                        </Button>
                                    </InputGroupAddon>
                                </InputGroup>
                                {
                                    this.state.wrong &&
                                    <FormText color="danger">
                                        <Icon icon="fa-exclamation-circle" />
                                        <span> Wrong Password, Try Again</span>
                                    </FormText>
                                }
                                <br /><br />
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Login.jsx